import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, ContentCard, HeaderCard, Icon, SubTitleCard, TitleCard } from '@weezevent/nacre';
import ModerationProfileRequesterInformationsForm from './moderationProfileRequesterInformationsForm';
import Style from '../../moderationProfile.module.css';

import { getTranslatedQuestionLabel } from './getTranslatedQuestionLabel';
import { formatForm } from './utils';

export default function ModerationProfileRequesterInformations({ order, organizationId, orderId, flowId, syncOrder, attendee }) {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const [editRequester, setEditRequester] = React.useState(false);
    const { language: locale } = i18n;

    const allFieldsNotEditable = order?.buyer_form?.every(item => !item.allow_modification);

    const buyerForm = React.useMemo(() => formatForm(order.buyer_form, t, locale), [order.buyer_form, locale, t]);

    return (
        <Card id="requester" className={`${Style['attendee-card']} ${Style['attendee-requesterInfos']}`}>
            <HeaderCard className={Style['attendee-cardInfos-header']}>
                <div>
                    <TitleCard title={t('ticket.moderation.attendee.requesterInformations.title')} />
                    <SubTitleCard title={t('ticket.moderation.attendee.requesterInformations.subtitle')} />
                </div>
                {!editRequester && buyerForm && !allFieldsNotEditable && (
                    <div className={Style['attendee-cardInfos-editCta']} onClick={() => setEditRequester(true)}>
                        <span>{t('ticket.common.action.modify')}</span>
                        <Icon name="edit" />
                    </div>
                )}
            </HeaderCard>
            <ContentCard>
                {buyerForm && buyerForm.length > 0 ? (
                    editRequester ? (
                        <ModerationProfileRequesterInformationsForm
                            organizationId={organizationId}
                            order={order}
                            orderId={orderId}
                            flowId={flowId}
                            syncOrder={syncOrder}
                            setEditRequester={setEditRequester}
                        />
                    ) : (
                        <ul className={Style['attendee-infos-listItem']}>
                            {buyerForm
                                .filter(entry => !(entry.field_type === 'file' || entry.field_type === 'divider'))
                                .sort((a, b) => a.order - b.order)
                                .map((formEntry, index) => (
                                    <li key={index}>
                                        <span className={Style['attendee-infos-listItem-label']}>{getTranslatedQuestionLabel(formEntry, locale)}</span>
                                        <b className={Style['attendee-infos-listItem-answer']}>{formEntry.text || ''}</b>
                                    </li>
                                ))}
                        </ul>
                    )
                ) : (
                    <Card.EmptyState
                        icon={<Icon name="list" />}
                        title={t('ticket.common.noData')}
                        subtitle={t('ticket.moderation.attendee.formEmptyStateSubtitle')}
                        labelButton={t('ticket.moderation.attendee.formEmptyStateCta')}
                        onClick={() => {
                            history.push(`/ticket/O${organizationId}/E${attendee.event_id}/settings/forms`);
                        }}
                    />
                )}
            </ContentCard>
        </Card>
    );
}
